import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useReceiptDescriptionsList() {
  // Use toast
  const toast = useToast();

  const refReceiptDescriptionListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    // { key: "id", label: "編號", sortable: true },
    // { key: "name", stickyColumn: true, label: "款項名稱", sortable: true },
    { key: "description",stickyColumn: true, label: "款項內容", sortable: true },
    { key: "is_active", label: "狀態", sortable: true },
    // { key: "sort_order", label: "排序", sortable: true },
    { key: "actions", label: "操作" },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const receiptDescriptionsList = ref(null);

  // const filter_receiptDescription_type_id = ref(null);
  // const filter_project_id = ref(null);
  // const filter_customer_id = ref(null);
  // const filter_product_id = ref(null);
  // const filter_quotation_id = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refReceiptDescriptionListTable.value
      ? refReceiptDescriptionListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refReceiptDescriptionListTable.value.refresh();
  };

  watch(
    [
      currentPage, perPage, searchQuery, 
      // filter_receiptDescription_type_id, filter_project_id, filter_customer_id,
      // filter_product_id, filter_quotation_id
    ],
    () => {
      refetchData();
    }
  );

  const fetchReceiptDescriptions = (ctx, callback) => {

    store
      .dispatch("receipt-description/fetchReceiptDescriptions", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        // receiptdescription_type_id: filter_receiptdescription_type_id.value,
        // quotation_id: filter_quotation_id.value,
        // project_id : filter_project_id.value,
        // customer_id: filter_customer_id.value,
        // product_id: filter_product_id.value
      })
      .then((response) => {
        const { receipt_descriptions, total } = response.data;
        callback(receipt_descriptions);
        totalRow.value = total;
        receiptDescriptionsList.value = receipt_descriptions
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取印章清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  // const receiptdescriptionTypeOptions = ref([]);
  // const quotationOptions = ref([]);
  // const customerOptions = ref([]);
  // const productOptions = ref([]);
  // const workerOptions = ref([]);
  // const projectOptions = ref([])

  // const refetchOption = () => {
  //   store
  //     .dispatch("app/fetchOptionList", {
  //       quotation_types: true,
  //       quotations: true,
  //       customers: true,
  //       products: true,
  //       projects: true,
  //     })
  //     .then((response) => {
  //       receiptdescriptionTypeOptions.value = response.data.quotation_types;
  //       quotationOptions.value = response.data.quotations;
  //       customerOptions.value = response.data.customers;
  //       productOptions.value = response.data.products;
  //       workerOptions.value = response.data.workers;
  //       projectOptions.value = response.data.projects;
  //     });
  // };

  onMounted(() => {
    // refetchOption();
  });

  return {
    fetchReceiptDescriptions,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    receiptDescriptionsList,
    refReceiptDescriptionListTable,
    ability,
    refetchData,
    // filter_receiptdescription_type_id,
    // filter_project_id,
    // filter_customer_id,
    // filter_product_id,
    // filter_quotation_id,
    // receiptdescriptionTypeOptions,
    // quotationOptions,
    // customerOptions,
    // productOptions,
    // workerOptions,
    // projectOptions,
  };
}
